import { ReactNode } from 'react'

export interface TwoColumnLayoutProps {
  /** Optional content for the top of the left section */
  topLeftContent?: ReactNode

  /** Main content for the left section, vertically centered */
  leftCenterContent: ReactNode

  /** Optional content for the bottom of the left section */
  bottomLeftContent?: ReactNode

  /** Content for the right column */
  rightColumn: ReactNode
}

export function TwoColumnLayout({
  topLeftContent,
  leftCenterContent,
  bottomLeftContent,
  rightColumn,
}: TwoColumnLayoutProps) {
  return (
    <div className='tw-grid tw-grid-cols-2 tw-h-screen tw-w-full'>
      {/* Left column */}
      <div className='tw-flex tw-flex-col tw-h-full'>
        {/* Top section if provided */}
        {topLeftContent && <div>{topLeftContent}</div>}

        {/* Center section - takes remaining space */}
        <div className='tw-flex-1'>{leftCenterContent}</div>

        {/* Bottom section if provided */}
        {bottomLeftContent && <div>{bottomLeftContent}</div>}
      </div>

      {/* Right column - takes full height and width */}
      <div className='tw-h-full tw-w-full'>{rightColumn}</div>
    </div>
  )
}
